<template>
  <div style="width: 100%;height: 100%;display: flex;justify-content: center;align-items: center;">
    <img src="../../assets/noMobile.png" style="width: 80vw;object-fit: contain"/>
  </div>

</template>

<script>
export default {
  name: "NoMobile",
  data() {
    return {
      dialog: true,
    };
  },
  methods: {
    goBack() {
      window.history.back();
    },
  },
};
</script>

<style scoped>
.main {
  width: 80vw;
  height: 80vh;
  background: linear-gradient(153deg, #e5ffec 0%, #e4e4ff 100%);
  border-radius: 16px;
  margin:0 auto; 
  margin-top: 10vh;
}
.content{
  padding-top: 50%;
  margin-left: 10%;
  width: 80%;
  font-size: 1rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3A3A3A;
  line-height: 2rem;
}
</style>
